<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-img
          :src="require('../assets/greennote.png')"
          class="my-3"
          contain
          height="200"
        />
      </v-col>

      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">
          グリーンノート オンライン研修 有償コース
        </h1>
      </v-col>

      <v-col class="mb-5" cols="12">
        <h2 class="headline font-weight-bold mb-3">
          あなたは下記の研修を受けられます。
        </h2>

        <v-row justify="center">
          <a
            v-for="(next, i) in getCourses(this.currentClientCode)"
            :key="i"
            :href="next.href"
            class="subheading mx-3"
          >
            {{ next.text }}
          </a>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// const getCourses = (clientCode) => {
//   return this.courses.filter((course) => {
//     if (course["clientCode"] == clientCode) {
//       return true;
//     }
//   });
// };

export default {
  name: "Paid",
  data: () => ({
    currentUser: "",
    currentClientCode: "",
    courses: [
      {
        text: "2021年9月　尾張繊維技術センター様",
        href: "cource/1/1",
        clientCode: "1",
      },
    ],
  }),

  methods: {
    getCourses: function(clientCode) {
      return this.courses.filter((course) => {
        if (course["clientCode"] == clientCode) {
          return true;
        }
      });
    },
  },

  mounted: function () {
    this.currentUser = this.$store.state.user.username;
    this.currentClientCode =
      this.$store.state.user.signInUserSession.idToken.payload[
        "cognito:groups"
      ][0];
    console.log(`User: ${this.currentUser}`);
    console.log(`Role: ${this.currentClientCode}`);
  },
};
</script>
<style>
.signin {
  margin: 20px;
}
input {
  font-size: 16px !important;
}
@media screen and (max-width: 480px) {
  .signin div {
    min-width: 0;
  }
}
</style>
